module.exports = __webpack_public_path__ + "img/platform_bg.01550f6.webp";